import { makeApolloClient, logError } from '../util';
import { CLIENT_ATTENDEES, EVENT_ATTENDEES } from 'queries/attendee';
export const SET_ATTENDEES = 'SET_ATTENDEES';
export const CLEAR_ATTENDEES = 'CLEAR_ATTENDEES_DATA';

const setAttendees = (attendees, from) => ({
	type: SET_ATTENDEES,
	attendees,
	from,
});

export const clearAttendees = from => ({
	type: CLEAR_ATTENDEES,
	from,
});

export const thunkFetchEventAttendees = (gqlParams, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventAttendees } = await client.request(EVENT_ATTENDEES, gqlParams);
		dispatch(setAttendees(eventAttendees, from));
		return eventAttendees.nodes;
	} catch (error) {
		logError('attendees.actions.thunkFetchEventAttendees', error);
	}
};

export const thunkFetchClientAttendees = (gqlParams, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { client_id, search_term, items_per_page, offset } = gqlParams;
		const { clientAttendees } = await client.request(CLIENT_ATTENDEES, {
			client_id,
			search_term,
			items_per_page,
			offset,
		});
		dispatch(setAttendees(clientAttendees, from));
	} catch (error) {
		logError('attendees.actions.thunkFetchClientAttendees', error);
	}
};
